import React from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('React Error Boundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-background p-4 text-foreground">
          <div className="w-full max-w-md rounded-3xl border border-white/[0.06] bg-card p-8 shadow-2xl">
            <h2 className="mb-3 text-2xl font-semibold text-red-400" style={{ fontFamily: "'Fraunces', Georgia, serif" }}>
              Something went wrong
            </h2>
            <p className="mb-4 text-muted-foreground">
              We apologize for the inconvenience. Please try refreshing the page.
            </p>
            {this.state.error && (
              <pre className="overflow-auto rounded-xl border border-white/[0.06] bg-secondary p-4 text-xs text-muted-foreground">
                {this.state.error.toString()}
              </pre>
            )}
            <button
              onClick={() => window.location.reload()}
              className="mt-5 w-full rounded-full bg-primary px-4 py-3 font-semibold text-primary-foreground transition-all hover:brightness-110"
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}